import React, { Component } from 'react';
import styled from 'styled-components';
import { getTheme, screen } from '../../global/utils';
import Auth from "../../services/Auth";

const BasicHeading = styled.div`
  line-height: ${getTheme('lineHeight', 'heading')};
  margin-bottom: ${props =>
    (props.nomargin === true && '0') ||
    (props.level === 'heading1' && getTheme('marginHeading', 'h1')) ||
    (props.level === 'heading2' && getTheme('marginHeading', 'h2')) ||
    (props.level === 'heading3' && getTheme('marginHeading', 'h3')) ||
    (props.level === 'heading4' && getTheme('marginHeading', 'h4')) ||
    (props.level === 'heading5' && getTheme('marginHeading', 'h5')) ||
    (props.level === 'heading6' && getTheme('marginHeading', 'h6'))};
  font-size: ${props =>
    (props.level === 'heading1' && getTheme('fontSize', 'headline')) ||
    (props.level === 'heading2' && getTheme('fontSize', 'title')) ||
    (props.level === 'heading3' && getTheme('fontSize', 'subheader')) ||
    (props.level === 'heading4' && getTheme('fontSize', 'body')) ||
    (props.level === 'heading5' && getTheme('fontSize', 'note')) ||
    (props.level === 'heading6' && getTheme('fontSize', 'caption'))};
  font-weight: ${props =>
    (props.level === 'heading1' && 300) ||
    (props.level === 'heading2' && 400) ||
    (props.level === 'heading3' && 600) ||
    (props.level === 'heading4' && 700) ||
    (props.level === 'heading5' && 700) ||
    (props.level === 'heading6' && 700)};
  text-transform: ${props => props.level === 'heading6' && 'uppercase'};

  svg {
    color: ${getTheme('textColor', 'disabled')};
    margin-right: ${getTheme('spacer', 'm')};
  }

  @media (max-width: ${screen('smMax')}) {
    font-size: ${props =>
      props.level === 'heading1' && getTheme('fontSize', 'title')};
  }
`;

const auth = new Auth();

class Heading extends Component {
  render() {
    let showItem = true;
    if (this.props.rol) {
        showItem = (auth.getRol() === this.props.rol);
    }
    if (!showItem) {
        return ('');
    }

    return (
      <BasicHeading className={this.props.className} nomargin={this.props.nomargin} level={this.props.level}>
        {this.props.children}
      </BasicHeading>
    );
  }
}

export default Heading;



// WEBPACK FOOTER //
// ./src/components/text/Heading.js